const Data = [
  {
    id: 1,
    title: 'As You Were - TrackTribe',
    artist: 'TrackTribe',
    thumbnail: require('../images/img01.jpg'),
    src: require('../musics/As You Were - TrackTribe.mp3')
  },
  {
    id: 2,
    title: 'Coast - Anno Domini Beats',
    artist: 'Anno Domini Beats',
    thumbnail: require('../images/img02.jpg'),
    src: require('../musics/Coast - Anno Domini Beats.mp3')
  },
  {
    id: 3,
    title: 'Here it Comes - TrackTribe',
    artist: 'TrackTribe',
    thumbnail: require('../images/img03.jpg'),
    src: require('../musics/Here it Comes - TrackTribe.mp3')
  },
  {
    id: 4,
    title: 'It Was a Time - TrackTribe',
    artist: 'TrackTribe',
    thumbnail: require('../images/img04.jpg'),
    src: require('../musics/It Was a Time - TrackTribe.mp3')
  },
  {
    id: 5,
    title: 'Mulholland - King Canyon',
    artist: 'King Canyon',
    thumbnail: require('../images/img05.jpg'),
    src: require('../musics/Mulholland - King Canyon.mp3')
  },
  {
    id: 6,
    title: 'No Mercy - TrackTribe',
    artist: 'TrackTribe',
    thumbnail: require('../images/img06.jpg'),
    src: require('../musics/No Mercy - TrackTribe.mp3')
  },
  {
    id: 7,
    title: 'Put It - TrackTribe',
    artist: 'TrackTribe',
    thumbnail: require('../images/img07.jpg'),
    src: require('../musics/Put It - TrackTribe.mp3')
  },
  {
    id: 8,
    title: 'Read All Over - Nathan Moore',
    artist: 'Nathan Moore',
    thumbnail: require('../images/img08.jpg'),
    src: require('../musics/Read All Over - Nathan Moore.mp3')
  },
  {
    id: 9,
    title: 'Silver Waves - TrackTribe',
    artist: 'TrackTribe',
    thumbnail: require('../images/img09.jpg'),
    src: require('../musics/Silver Waves - TrackTribe.mp3')
  }
]


export default Data;